import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Box, Typography, Checkbox, FormControlLabel } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setSuccessNotification, setErrorNotification } from '../../actions/notificationAction';
import { OrderApi } from '../../api/orderApi';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import useTranslation from '../../hooks/useTranslation';

const ManualFulfillment = ({ order }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const dispatch = useDispatch();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCheckboxChange = (itemId) => {
    setSelectedItems((prev) =>
      prev.includes(itemId) ? prev.filter(id => id !== itemId) : [...prev, itemId]
    );
  };

  const handleFulfillment = async () => {
    if (selectedItems.length === 0) {
      dispatch(setErrorNotification({ message: t('labels.please_select_items') }));
      return;
    }
    try {
      const response = await OrderApi.manualFulfill(order.id, { itemIds: selectedItems });
      if (response.status === 200) {
        dispatch(setSuccessNotification({ message: t('labels.fulfillment_success') }));
        handleClose();
      } else {
        dispatch(setErrorNotification({ message: response.data.message }));
      }
    } catch (error) {
      dispatch(setErrorNotification({ message: error?.response?.data?.message || t('labels.fulfillment_error') }));
    }
  };

  const groupedItems = order.order_items.reduce((acc, item) => {
    const fulfillmentCenter = item.product.fulfillmentCenter?.name || 'Default';
    if (!acc[fulfillmentCenter]) {
      acc[fulfillmentCenter] = [];
    }
    acc[fulfillmentCenter].push(item);
    return acc;
  }, {});

  return (
    <>
      {!order.orderFulfillments?.length && (
        <Button variant="outlined" color="primary" onClick={handleOpen} sx={{ textTransform: 'none' }}>
          {t('labels.custom_fulfillment')}
        </Button>
      )}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogContent dividers sx={{ padding: '20px' }}>
          <Typography variant="body1" sx={{ marginBottom: '10px' }}>
            {t('labels.select_items_for_custom_fulfillment')}
          </Typography>
          {Object.keys(groupedItems).map((fulfillmentCenterName) => (
            <Box key={fulfillmentCenterName} sx={{ marginBottom: '15px', padding: '10px', borderRadius: '8px', backgroundColor: '#f9f9f9' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>
                <LocalShippingIcon sx={{ verticalAlign: 'middle', marginRight: '5px' }} />
                {fulfillmentCenterName}
              </Typography>
              {groupedItems[fulfillmentCenterName].map(item => (
                <FormControlLabel
                  key={item.id}
                  control={<Checkbox checked={selectedItems.includes(item.id)} onChange={() => handleCheckboxChange(item.id)} />}
                  label={`${item.product.name} - ${item.quantity} x ${item.price}`}
                  sx={{ display: 'block', paddingLeft: '20px' }}
                />
              ))}
            </Box>
          ))}
        </DialogContent>
        <DialogActions sx={{ padding: '15px', justifyContent: 'space-between' }}>
          <Button onClick={handleClose} color="primary" variant="outlined">{t('labels.cancel')}</Button>
          <Button onClick={handleFulfillment} color="primary" variant="contained">{t('labels.process_selected_items')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ManualFulfillment;